import React from 'react';
import { Typography, Image } from 'lib/components';
import { useWindowResize } from 'hooks/useWindowResize';
import { JobFile } from 'types';
import { useAppDispatch, actions } from 'store';
import classes from './index.module.scss';

/**
 * Props interface for the FileDelete component
 */
interface Props {
	/** Job file object containing file metadata */
	file: JobFile;
	/** ID of the job that the file belongs to */
	jobId: number;
}

/**
 * FileDelete component
 * Renders a button that allows users to delete a job file
 * Dispatches the deleteDocument action when clicked
 * Adapts typography size based on device screen size
 *
 * @param {Props} props - Component props
 * @returns {JSX.Element} - Rendered component
 */
const FileDelete = ({ file, jobId }: Props) => {
	// Get device size information for responsive design
	const { isSmallerDevice } = useWindowResize();

	// Redux dispatch function for triggering actions
	const dispatch = useAppDispatch();

	return (
		<button
			className={`${classes['file-container']} ${classes['file-container-delete']}`}
			style={{
				width: '20rem',
				justifyContent: 'space-between',
			}}
			// Dispatch action to delete the document when clicked
			onClick={() => dispatch(actions.deleteDocument(file.id, jobId))}
		>
			{/* Display file name with responsive typography */}
			<Typography variant={isSmallerDevice ? 'h5' : 'h6'} color="gray">
				{file.name}
			</Typography>
			{/* Trash icon */}
			<Image src="icTrashDanger" />
		</button>
	);
};

export default FileDelete;
